import { Action } from '@canvas/model/permissions';

import type { Policy } from '../../policy-manager-types';

export const cannotDeleteComment: Policy = {
  id: 'cannot-delete-comment',
  type: 'transient',
  rule: () => {
    return { cannot: Action['delete/comment'] };
  },
};
